import PageHeader from "../../../components/choose-plan/components/page-header"
import { getFaltenSubTreatmentGoalList } from "../utils/questionnaire-helper"

import PillList from "./pill-list"
import Products from "./products"

function Hero() {
  const subTreatmentGoalList = getFaltenSubTreatmentGoalList()

  return (
    <div
      sx={{
        width: ["100vw", "100%"],
        position: "relative",
        left: ["50%", 0],
        mr: [null, "auto"],
        ml: ["-50vw", 0],
        display: "flex",
        flexDirection: "column",
        rowGap: 4,
        pt: "40px",
        pb: 5,
        px: 5,
        backgroundColor: "#1A1C2B",
        borderRadius: "0px 0px 32px 32px",
      }}
    >
      <PageHeader
        headline={
          <span sx={{ fontWeight: "bold" }}>
            {"Dein FORMEL SKIN-Set für sichtbar jüngere Haut"}
          </span>
        }
        sx={{
          color: "#FFF",
          m: 0,
          columnGap: 5,
          "& .gatsby-image-wrapper": {
            bg: "#1A1C2B",
            borderRadius: "50%",
          },
        }}
      />
      <p
        sx={{
          color: "#E5E5E5",
          fontSize: 2,
          fontWeight: 400,
          m: 0,
          lineHeight: 1.5,
        }}
      >
        Wir haben eine hochwirksame Pflege entwickelt – individuell auf Dich
        abgestimmt, gegen Deine Zeichen der Hautalterung.
      </p>
      <PillList items={subTreatmentGoalList} />
      <Products />
    </div>
  )
}

export default Hero
